<template>
  <div>
    <!-- <Header /> -->

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="relative py-16 bg-white my-16 md:my-36">
        <div
          class="hidden absolute top-0 inset-x-0 h-1/2 bg-gray-50 lg:block"
          aria-hidden="true"
        ></div>
        <div class="max-w-7xl mx-auto bg-blue-900 lg:bg-transparent lg:px-8">
          <div class="lg:grid lg:grid-cols-12">
            <div
              class="relative z-10 lg:col-start-1 lg:row-start-1 lg:col-span-4 lg:py-16 lg:bg-transparent"
            >
              <!-- <div
              class="absolute hidden inset-x-0 h-1/2 bg-gray-50"
              aria-hidden="true"
            ></div> -->
              <div
                class="max-w-md mx-auto px-4 pt-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0"
              >
                <div
                  class="aspect-w-10 aspect-h-6 sm:aspect-w-2 sm:aspect-h-1 lg:aspect-w-1"
                >
                  <img
                    class="object-cover object-center rounded-3xl shadow-2xl"
                    src="/images/main_page_01.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <div
              class="relative bg-blue-900 lg:col-start-3 lg:row-start-1 lg:col-span-10 lg:rounded-3xl lg:grid lg:grid-cols-10 lg:items-center"
            >
              <div
                class="hidden absolute inset-0 overflow-hidden rounded-3xl lg:block"
                aria-hidden="true"
              >
                <svg
                  class="absolute bottom-full left-full transform translate-y-1/3 -translate-x-2/3 xl:bottom-auto xl:top-0 xl:translate-y-0"
                  width="404"
                  height="384"
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x="0"
                        y="0"
                        width="4"
                        height="4"
                        class="text-blue-900"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width="404"
                    height="384"
                    fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                  />
                </svg>
                <svg
                  class="absolute top-full transform -translate-y-1/3 -translate-x-1/3 xl:-translate-y-1/2"
                  width="404"
                  height="384"
                  fill="none"
                  viewBox="0 0 404 384"
                  aria-hidden="true"
                >
                  <defs>
                    <pattern
                      id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                      patternUnits="userSpaceOnUse"
                    >
                      <rect
                        x="0"
                        y="0"
                        width="4"
                        height="4"
                        class="text-indigo-500"
                        fill="currentColor"
                      />
                    </pattern>
                  </defs>
                  <rect
                    width="404"
                    height="384"
                    fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                  />
                </svg>
              </div>
              <div
                class="relative max-w-md mx-auto py-12 px-4 space-y-6 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 lg:col-start-4 lg:col-span-6"
              >
                <h2
                  class="text-3xl font-extrabold text-white"
                  id="join-heading"
                >
                  УЧИТЕСЬ ОНЛАЙН 
                </h2>
                <p class="text-lg text-white">
От обучения на всю жизнь – к обучению через всю жизнь: эти слова полностью соответствуют задачам, которые ставятся последипломным медицинским образованием.
В медицине быстро меняются стандарты, появляются новые методы диагностики и лечения, внедряются инновационные лекарственные препараты. Современная медицина – это новые знания, внедренные в практическую деятельность на всех уровнях медицинской помощи. Врач не может просто отучиться, получить диплом и спокойно работать. Врачи ежедневно соревнуются с болезнью, должны играть на опережение, знать самые современные методы и протоколы, учиться и развиваться.

                </p>
                <a
                  class="block w-full py-3 px-5 text-center bg-white border border-transparent rounded-md shadow-md text-base font-medium text-indigo-700 hover:bg-gray-50 sm:inline-block sm:w-auto"
                  href="#opfdm"
                  >Узнать больше</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- This example requires Tailwind CSS v2.0+ -->
      <div class="pt-12 bg-white my-16 md:my-36" id="opfdm">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div class="lg:text-center">
            <h2
              class="text-base text-indigo-600 font-semibold tracking-wide uppercase"
            >
              <!-- Преимущества -->
            </h2>
            <p
              class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl"
            >
              Образовательная платформа Фонда доказательной медицины
            </p>
            <p class="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              Это абсолютно бесплатный образовательный ресурс с программами повышения квалификации медицинских работников.
            </p>
          </div>

          <div class="mt-10">
            <dl
              class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10"
            >
              <div v-for="plus in pluses" v-bind:key="plus.id" class="relative">
                <dt>
                  <div
                    class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-transparent text-white"
                  >
                    <!-- Heroicon name: outline/globe-alt -->
                    <img :src="plus.image" alt="" />
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                    {{ plus.caption }}
                  </p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  {{ plus.text }}
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      <!-- Testimonials -->
      <!--
      <section class="bg-white overflow-hidden my-16 md:my-36">
        <div
          class="relative max-w-3xl mx-auto pt-20 pb-12 px-4 sm:px-6 lg:px-8 lg:py-20"
        >
          <svg
            class="absolute top-full left-0 transform translate-x-80 -translate-y-24 lg:hidden"
            width="784"
            height="404"
            fill="none"
            viewBox="0 0 784 404"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="784"
              height="404"
              fill="url(#e56e3f81-d9c1-4b83-a3ba-0d0ac8c32f32)"
            />
          </svg>

          <svg
            class="hidden lg:block absolute right-full top-1/2 transform translate-x-1/2 -translate-y-1/2"
            width="404"
            height="784"
            fill="none"
            viewBox="0 0 404 784"
            aria-hidden="true"
          >
            <defs>
              <pattern
                id="56409614-3d62-4985-9a10-7ca758a8f4f0"
                x="0"
                y="0"
                width="20"
                height="20"
                patternUnits="userSpaceOnUse"
              >
                <rect
                  x="0"
                  y="0"
                  width="4"
                  height="4"
                  class="text-gray-200"
                  fill="currentColor"
                />
              </pattern>
            </defs>
            <rect
              width="404"
              height="784"
              fill="url(#56409614-3d62-4985-9a10-7ca758a8f4f0)"
            />
          </svg>

          <div class="relative lg:flex lg:items-center">
            <div class="hidden lg:block lg:flex-shrink-0">
              <img
                class="h-16 w-16 rounded-full xl:h-50 xl:w-50"
                :src="testimonials[0].image"
                alt=""
              />
            </div>

            <div class="relative lg:ml-10">
              <svg
                class="absolute top-4 left-0 transform -translate-x-8 -translate-y-24 h-16 w-16 text-indigo-200 opacity-50"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 144 144"
                aria-hidden="true"
              >
                <path
                  stroke-width="2"
                  d="M41.485 15C17.753 31.753 1 59.208 1 89.455c0 24.664 14.891 39.09 32.109 39.09 16.287 0 28.386-13.03 28.386-28.387 0-15.356-10.703-26.524-24.663-26.524-2.792 0-6.515.465-7.446.93 2.327-15.821 17.218-34.435 32.11-43.742L41.485 15zm80.04 0c-23.268 16.753-40.02 44.208-40.02 74.455 0 24.664 14.891 39.09 32.109 39.09 15.822 0 28.386-13.03 28.386-28.387 0-15.356-11.168-26.524-25.129-26.524-2.792 0-6.049.465-6.98.93 2.327-15.821 16.753-34.435 31.644-43.742L121.525 15z"
                />
              </svg>
              <blockquote class="relative">
                <div class="text-2xl leading-9 font-medium text-gray-900">
                  <p>
                    {{ testimonials[0].text }}
                  </p>
                </div>
                <footer class="mt-8">
                  <div class="flex">
                    <div class="flex-shrink-0 lg:hidden">
                      <img
                        class="h-12 w-12 rounded-full"
                        :src="testimonials[0].image"
                        alt=""
                      />
                    </div>
                    <div class="ml-4 lg:ml-0">
                      <div class="text-base font-medium text-gray-900">
                        {{ testimonials[0].name }}
                      </div>
                      <div class="text-base font-medium text-indigo-600">
                        {{ testimonials[0].profession }}
                      </div>
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div>
          </div>
        </div>
      </section>
      -->


      <div class="text-center">
        <a
          v-if="!authenticated"
          class="block w-full py-3 px-5 text-center text-3xl bg-white border border-transparent rounded-md shadow-md text-base font-medium text-gray-500 hover:bg-gray-200 sm:inline-block sm:w-auto"
          href="/register#reg"
        >
          Регистрация
        </a>
      </div>

      <!-- Logo Cloud -->
      <div class="">
        <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
          <p
            class="text-center text-sm font-semibold uppercase text-gray-500 tracking-wide"
          >
            <!-- Trusted by -->
          </p>
          <div class="mt-6 grid grid-cols-1 gap-8 md:grid-cols-2">
            <div
              class="col-span-1 flex justify-center md:col-span-2 md:col-start-2 lg:col-span-1"
            >
              <img class="h-16" src="/images/LOGO_FOND_01.png" alt="" />
            </div>
            <div
              class="col-span-2 flex justify-center md:col-span-2 md:col-start-4 lg:col-span-1"
            >
              <img class="h-10 pt-1" src="/images/fdm-logo-full.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <!-- Отзывы -->
      <!-- <div class="section p-5 mt-1">
      <h3 class="text-center mt-3 mb-5">
        Более 10000 человек уже окончили наши курсы
      </h3>
      <div id="testimonials-slider" class="mt-5">
        <div
          v-for="tm in testimonials"
          v-bind:key="tm.id"
          class="p-3 text-center"
        >
          <img
            :src="tm.image"
            class="d-block testimonials-slider__image mx-auto mb-3"
            alt=""
          />
          <h5>{{ tm.name }}</h5>
          <p style="font-weight: bold">{{ tm.profession }}</p>
          <p style="font-style: italic">{{ tm.text }}</p>
        </div>
      </div>
    </div> -->
    </div>
  </div>
</template>
<script>
import jQuery from "jquery";
import "lightslider";
import { mapGetters } from "vuex";
// import Header from "@/components/Header";

export default {
  components: {
    // Header,
  },
  data() {
    return {
      // наши преимущества:
      pluses: [
        {
          id: 1,
          image: "/images/c3-1.svg",
          caption: "Проходите курсы",
          text:
            "Дистанционный формат обучения позволяет различным сотрудникам медицинской организации без отрыва от работы повышать свой уровень квалификации вне зависимости от региона проживания. В разработке программ образовательных программам на данной платформе участвовали практикующие врачи, имеющие ученые степени и звания, а также многолетний опыт работы и участия в клинических исследованиях.",
        },
        {
          id: 2,
          image: "/images/c3-2.svg",
          caption: "Развивайте навыки",
          text: "Помимо образовательных программ на регулярной основе на портале публикуются результаты исследований, клинические разборы, интервью с ведущими специалистами, международные и российские новости.",
        },
        {
          id: 3,
          image: "/images/c3-3.svg",
          caption: "Работайте над собой",
          text:
            "Каждая программа включает в себя: тематические модули в формате видео-лекций с разборами реальных клинических случаев в медицинской практики, тестирование по итогам прохождения каждого модуля, а также итоговое тестирование."
        },
        {
          id: 4,
          image: "/images/c3-4.svg",
          caption: "Узнавайте новое",
          text: "Также специально для пациентов на портале есть раздел с комментариями врачей, памятками и записями мастер классов.",
        },
      ],
      // отзывы:
      /*
            testimonials: [
                { id: 1, name: 'Maria Montes',     profession: 'Web-developer',    image: '/images/woman.svg',     text: '"Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam eligendi similique dignissimos dolore fuga saepe!"' },
                { id: 2, name: 'Huge Gonsales',    profession: 'Data Scientist',   image: '/images/woman2.svg',    text: '"Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam!"' },
                { id: 3, name: 'Tom Goodman',      profession: 'QA Engineer',      image: '/images/buddha.svg',    text: '"Sit et mollitia ea, labore repellat nobis aliquam at velit dolorum porro consectetur quo eum aperiam eligendi similique dignissimos dolore fuga saepe!"' },
                { id: 4, name: 'Jessica Brown',    profession: 'Web-developer',    image: '/images/lotus.svg',     text: '"Lorem ipsum dolor sit amet consectetur adipisicing elit."' },
            ],
            */
      testimonials: [
        {
          id: 1,
          name: "Владимир Артемьев",
          profession: "Веб-разработчик",
          image: "/images/person3.jpg",
          text:
            "Курсы научили меня подхватывать идеи на лету и применять их на практике.",
        },
        {
          id: 2,
          name: "Елена Буравина",
          profession: "Инженер",
          image: "/images/person4.jpg",
          text:
            "Очень полезные и интересные курсы! Мне понравилось, что много практических навыков смогла подчеркнуть для себя!",
        },
        {
          id: 3,
          name: "Татьяна Соколова",
          profession: "Ведущий специалист",
          image: "/images/person5.jpg",
          text:
            "Спасибо! Без нового уровня я бы не смогла работать - это не комплимент, это факт. Спасибо за то, что Вы делаете.",
        },
        {
          id: 4,
          name: "Роман Быков",
          profession: "Администратор",
          image: "/images/person6.jpg",
          text:
            "Ваши знания и опыт бесценен! Вы задаете очень высокие стандарты, на вас хочется ровняться!",
        },
      ],
    };
  },
  mounted() {
    jQuery("#testimonials-slider").lightSlider({
      item: 4,
      autoWidth: false,
      slideMove: 1, // slidemove will be 1 if loop is true
      slideMargin: 30,
      loop: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            item: 3,
            slideMargin: 20,
          },
        },
        {
          breakpoint: 768,
          settings: {
            item: 2,
            slideMargin: 10,
          },
        },
        {
          breakpoint: 576,
          settings: {
            item: 1,
          },
        },
      ],
    });
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
    }),
  },

};
</script>



